import { openSkipAMonthModal } from 'compositions/modals/skipAMonth'


type OpenUnsubscribeSkipAMonthModalProps = {
  openNextModal: () => void
}


// little wrapper to keep flow in the same place
export const openUnsubscribeSkipAMonthModal = ({ openNextModal }: OpenUnsubscribeSkipAMonthModalProps) => {
  openSkipAMonthModal({
    isUnsubscribeFlow: true,
    openNextModal,
  })
}
